import { useEffect } from "react";

/**
 * useJsonLd — injects a JSON-LD <script> tag into <head> for a single
 * component (Article / ItemList / BreadcrumbList / …) and cleans it up
 * on unmount. Multiple instances co-exist via the `id` slot.
 *
 * Usage:
 *   useJsonLd("article-essay-slug", {
 *       "@context": "https://schema.org",
 *       "@type": "Article",
 *       ...
 *   });
 */
export default function useJsonLd(id, data) {
    const payload = data ? JSON.stringify(data) : null;
    useEffect(() => {
        if (!payload || !id) return;
        const selector = `script[data-jsonld-id="${id}"]`;
        let el = document.head.querySelector(selector);
        if (!el) {
            el = document.createElement("script");
            el.type = "application/ld+json";
            el.setAttribute("data-jsonld-id", id);
            document.head.appendChild(el);
        }
        el.textContent = payload;
        return () => {
            const node = document.head.querySelector(selector);
            if (node) document.head.removeChild(node);
        };
    }, [id, payload]);
}
